import { styled } from '@mui/material';

// eslint-disable-next-line import/prefer-default-export
export const BackLink = styled('div')(({ theme }) => ({
  a: {
    cursor: 'pointer',
    textDecoration: 'none',

    '.MuiTypography-root': {
      color: theme.palette.grey[600],
    },

    '&:hover .MuiTypography-root': {
      color: theme.palette.primary.main,
    },
  },
}));
